<script>
import LayoutMain from "@/router/layouts/main";
import LayoutExperts from "@/router/layouts/experts";
import { api } from "@/state/services";

// Cancelamento da fatura pendente
export default {
  components: {
    LayoutMain,
    LayoutExperts,
  },
  data() {
    return {
      loading: true,
      errored: false,
      submitting: false,

      pending: null,
    };
  },
  computed: {
    // Sem plano do Experts ativo usa o layout sem menu; com plano ativo mantém o menu
    layout() {
      const user = this.$store.state.account.user;
      return user && user.expert == 'active' ? 'LayoutMain' : 'LayoutExperts';
    },
  },
  methods: {
    load() {
      this.loading = true;
      this.errored = false;

      api
        .get('experts/current')
        .then(response => {
          if (response.data.status == 'success') {
            this.pending = response.data.pending;
          }

          // Sem fatura pendente para cancelar
          if (!this.pending || this.pending.status != 'pending') {
            this.$router.replace('/experts');
          }
        })
        .catch(() => {
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancel() {
      this.submitting = true;

      api
        .post('experts/cancel', { confirm: 'yes' })
        .then(response => {
          if (response.data.status == 'success') {
            this.$toast.success(response.data.message);
            this.$router.push('/experts');
          } else {
            this.$toast.error(response.data.message);
          }
        })
        .catch(() => {
          this.$toast.error('Não foi possível cancelar a fatura, tente novamente.');
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<template>
  <component :is="layout">
    <div class="experts">
      <router-link to="/experts" class="experts-back">
        <i class="bx bx-left-arrow-alt" aria-hidden="true"></i> Voltar
      </router-link>

      <div v-if="loading" class="text-center py-5">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
      <div v-else-if="errored" class="experts-box text-center">
        <p>Pedimos desculpas, não podemos recuperar as informações neste momento.</p>
        <button class="btn btn-default" v-on:click="load()">Tentar novamente</button>
      </div>
      <div v-else-if="pending" class="experts-box experts-summary experts-result">
        <div class="text-center">
          <i class="bx bx-x-circle experts-result-icon" aria-hidden="true"></i>
          <h1 class="experts-title">Cancelar fatura</h1>
          <p class="experts-subtitle mb-4">Confira a fatura que será cancelada.</p>
        </div>

        <dl>
          <div>
            <dt>Plano</dt>
            <dd>{{ pending.plan.name }}</dd>
          </div>
          <div>
            <dt>Vence em</dt>
            <dd>{{ pending.expires }}</dd>
          </div>
          <div class="is-total">
            <dt>Total</dt>
            <dd>{{ pending.total | currency }}</dd>
          </div>
        </dl>

        <div class="experts-note">
          <i class="bx bx-info-circle" aria-hidden="true"></i>
          <span>O PIX gerado para esta fatura deixará de valer. Você poderá escolher um plano novamente quando quiser.</span>
        </div>

        <button class="btn btn-danger btn-lg btn-block text-uppercase" v-on:click="cancel()" :disabled="submitting">
          Cancelar fatura
          <b-spinner v-if="submitting" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
        </button>
        <router-link tag="a" to="/experts" class="btn btn-outline-default btn-lg btn-block text-uppercase mt-2">
          Manter fatura
        </router-link>
      </div>
    </div>
  </component>
</template>
